import { type DocNode } from '@atlaskit/adf-schema';
import {
	isStoreAssistant,
	isStoreHuman,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

export type AutocompleteContextMessage = {
	id: string;
	content: string | DocNode;
};

export type AutocompleteContextMessages = {
	key: string;
	messages: AutocompleteContextMessage[];
};

export const getAutocompleteContextMessages = (
	storeMessages: StoreChatItem[],
): AutocompleteContextMessages => {
	const messages: AutocompleteContextMessage[] = [];
	const keyParts: string[] = [];

	for (const message of storeMessages) {
		if (isStoreHuman(message)) {
			const contextMessage = {
				id: message.content.id,
				content: message.content.content,
			};
			messages.push(contextMessage);
			keyParts.push(`human:${contextMessage.id}`);
			continue;
		}

		if (isStoreAssistant(message) && message.content.streamingComplete) {
			// Keep ADF responses too; getContext flattens them like human messages.
			const contextMessage = {
				id: message.content.message.message.id,
				content: message.content.message.message.content,
			};
			messages.push(contextMessage);
			keyParts.push(`assistant:${contextMessage.id}`);
		}
	}

	return {
		key: keyParts.join('|'),
		messages,
	};
};
